module.exports = __webpack_public_path__ + "static/img/2.c74d9a5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news6/2.jpg
// module id = hc0n
// module chunks = 1